import { createPortal } from "react-dom";
import { Rect } from "PosterEditor/model/poster-types";
import { ComponentLoadingIndicator } from "admin/shared-components/page-loading-indicator";
import styles from "./ViewportLoadingOverlay.module.css";

interface ViewportLoadingOverlayProps {
  viewportRect: Rect;
  mapContainerRect: DOMRect;
}

export const ViewportLoadingOverlay = ({
  viewportRect,
  mapContainerRect,
}: ViewportLoadingOverlayProps) => {
  const overlayLeft = mapContainerRect.x + viewportRect.x;
  const overlayTop = mapContainerRect.y + viewportRect.y;

  return createPortal(
    <div
      className={styles.overlay}
      style={{
        position: "absolute",
        left: `${overlayLeft}px`,
        top: `${overlayTop}px`,
        width: `${viewportRect.width}px`,
        height: `${viewportRect.height}px`,
      }}
    >
      <ComponentLoadingIndicator />
    </div>,
    document.body
  );
};
